import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Activity } from '../../components/economicactivity/ui'; 
const EconomicActivityPage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>ВЭД</title>
            </Helmet>
            <Activity/>
            {/* <AppHeader title={t('apps')} /> */}
            {/* <Apps /> */}
        </>
    );
};

export default EconomicActivityPage
